import React from "react";
import { Fade } from "react-reveal";
import "./Highlights.css";

const HIGHLIGHTS = [
  { number: "10+", label: "Years building iOS apps" },
  { number: "25+", label: "Apps shipped to the App Store" },
  { number: "2", label: "Top 10 rankings in the US App Store" },
  { number: "99%", label: "Crash-free reliability for millions of users" },
];

export default function Highlights({ theme }) {
  return (
    <Fade bottom duration={1500} distance="30px">
      <section className="highlights-section" aria-label="Career highlights">
        <div className="highlights-grid">
          {HIGHLIGHTS.map((item) => (
            <div
              key={item.label}
              className="highlight-card"
              style={{
                background: theme.highlight,
                borderColor: `${theme.text}1A`,
              }}
            >
              <div
                className="highlight-number"
                style={{ color: theme.headerColor || theme.text }}
              >
                {item.number}
              </div>
              <div
                className="highlight-label"
                style={{ color: theme.secondaryText }}
              >
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </section>
    </Fade>
  );
}
